"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var marquee_1 = require("../marquee");
var getIconName = function (iconName, error, warning, success) {
    if (iconName) {
        return iconName;
    }
    if (error) {
        return "icon-rejected-status";
    }
    if (warning) {
        return "icon-warning";
    }
    if (success) {
        return "icon-approved-status";
    }
    return "";
};
var Notification = /** @class */ (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onMouseEnter = function (e) {
            var onMouseEnter = _this.props.onMouseEnter;
            _this.cancelTimer();
            onMouseEnter && onMouseEnter(e);
        };
        _this.onMouseLeave = function (e) {
            var onMouseLeave = _this.props.onMouseLeave;
            _this.setTimer();
            onMouseLeave && onMouseLeave(e);
        };
        _this.onCloseClick = function (e) {
            var onClose = _this.props.onClose;
            onClose(false);
        };
        _this.timer = null;
        return _this;
    }
    Notification.prototype.componentDidMount = function () {
        this.setTimer();
    };
    Notification.prototype.setTimer = function () {
        var _a = this.props, timeout = _a.timeout, onClose = _a.onClose;
        if (timeout) {
            this.timer = setTimeout(function () { return onClose(true); }, timeout);
        }
    };
    Notification.prototype.cancelTimer = function () {
        clearTimeout(this.timer);
        this.timer = null;
    };
    Notification.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, error = _b.error, warning = _b.warning, success = _b.success, content = _b.content, onClose = _b.onClose, title = _b.title, text = _b.text, iconSize = _b.iconSize, iconName = _b.iconName, timeout = _b.timeout, closeBtn = _b.closeBtn, others = tslib_1.__rest(_b, ["theme", "className", "error", "warning", "success", "content", "onClose", "title", "text", "iconSize", "iconName", "timeout", "closeBtn"]);
        var classes = classnames_1.default(theme.notification, className, (_a = {},
            _a[theme.error] = error,
            _a[theme.warning] = warning,
            _a[theme.success] = success,
            _a));
        var events = {};
        if (timeout) {
            events.onMouseEnter = this.onMouseEnter;
            events.onMouseLeave = this.onMouseLeave;
        }
        var selectedIconName = getIconName(iconName, error, warning, success);
        return (React.createElement("div", tslib_1.__assign({}, others, { className: classes }, events),
            React.createElement("div", { className: theme.inner },
                selectedIconName
                    ? React.createElement(icon_1.Icon, { className: theme.icon, iconName: selectedIconName, size: iconSize })
                    : null,
                React.createElement("div", { className: theme.content },
                    title
                        ? React.createElement("div", { className: theme.title }, title)
                        : null,
                    text
                        ? React.createElement(marquee_1.Marquee, { active: true },
                            React.createElement("div", { className: theme.text, dangerouslySetInnerHTML: { __html: text } }))
                        : null,
                    content ? content : null),
                closeBtn ? (React.createElement("div", { className: theme.close, onClick: this.onCloseClick },
                    React.createElement(icon_1.Icon, { iconName: "icon-cancel-small", size: 1.4 }))) : null)));
    };
    Notification.defaultProps = {
        iconSize: 3.6,
        timeout: 0,
        onClose: utils_1.noop,
        closeBtn: true
    };
    return Notification;
}(React.Component));
exports.default = Notification;
